export const projects = [

   
    {
        title: "Welicit",
        subtitle: "2021",
        image: "./assets/images/welicit.png",
        description: "A Wizard of Oz tool to configure, run and analyze elicitation studies for immersive environments.",
        video: "https://www.youtube.com/watch?v=ov3TvXs8QzE",
        publication: "https://link.springer.com/chapter/10.1007/978-3-030-85607-6_6"

    },

    {
        title: "T4TAGS",
        subtitle: "2015-2021",
        image: "./assets/images/t4tags.jpg",
        description: "A tangible, programmable toolkit to support end-users in the serendipitous use of domestic technologies.",
        video: "https://www.youtube.com/watch?v=VYpOVchUCAQ",
        publication: "https://www.sciencedirect.com/science/article/abs/pii/S1071581918305093"

    },

    {
        title: "RE/Lab AAC",
        subtitle: "2018",
        image: "./assets/images/adi.jpg",
        description: "Disability design fieldwork with indigenous community in Cochabamba, Bolivia.",
        publication: "https://dsq-sds.org/article/view/5934/5144"
    },
    
    {
        title: "X-Reality Toolkit",
        subtitle: "2017",
        image: "./assets/images/xrtoolkit.png",
        description: "An end-user toolkit that provides a visual integrated environment for the rapid prototyping of XR interactions. ",
        video: "https://youtu.be/gsM5JiWpNi8",
        publication: "https://dl.acm.org/doi/abs/10.1145/3024969.3024975"
    },

    {
        title: "Social Display",
        subtitle: "2015",
        image: "./assets/images/socialdisplay.jpeg",
        video: "https://www.youtube.com/watch?v=ie3p9XrD02E",
        publication: "https://dl.acm.org/doi/abs/10.1145/3230675",
        description: "A see-through display for interactive museum showcases that allows to create and share digital narratives associated with physical artifacts."
    },

    {
        title: "ECCE Toolkit",
        subtitle: "2014",
        image: "./assets/images/ecce.jpg",
        publication: "https://dl.acm.org/doi/abs/10.1145/2540930.2567905",
        description: "A visual EUD toolkit to seamlessly create interactions between heterogeneous networked devices."
    },

    {
        title: "TESIS",
        subtitle: "2011",
        image: "./assets/images/tesis.jpeg",
        video: "https://www.youtube.com/watch?v=Whgby39qxg8",
        publication: "https://dl.acm.org/doi/abs/10.1145/2076354.2076417",
        description: "A DIY portable device using the Microsoft Kinect hardware for converting any non-flat surface into a multi-touch tabletop."
    },

    {
        title: "eStorys",
        subtitle: "2011",
        image: "./assets/images/estorys.jpg",
        publication: "https://e-archivo.uc3m.es/handle/10016/13957",
        description: "A mashup system for helping people and professionals to interact with georeferenced information about emergencies. "
    },

    {
        title: "Don't touch me",
        subtitle: "2010",
        image: "./assets/images/donttouchme.jpeg",
        video: "https://www.youtube.com/watch?v=fzmEBD9TaRY&t=132s",
        publication: "https://dl.acm.org/doi/abs/10.1145/1842993.1843072",
        description: "An exploration of remote interaction with map-based applications in large displays environments."
    },

   
    
]